/* eslint-disable @typescript-eslint/no-explicit-any */
import { NodeService } from './NodeService';
import { WorkflowBaseService } from './WorkflowBaseService';
import { NodeDefinitionService } from './NodeDefinitionService';
import { NodeExecutionService } from './NodeExecutionService';

export class WorkflowService {
  /**
   * Carrega um workflow pelo ID
   * @param workflowId - ID do workflow
   * @returns Configurações do workflow
   */
  static async loadWorkflow(workflowId: string) {
    try {
      const workflow = await WorkflowBaseService.getById(workflowId);
      return workflow?.settings;
    } catch (error) {
      console.error(`Erro ao carregar workflow ${workflowId}:`, error);
      throw error;
    }
  }

  /**
   * Carrega a definição de um nó pelo ID
   * @param nodeId - ID do nó
   * @returns Definição completa do nó
   */
  static async loadNodeDefinition(nodeId: string) {
    const { data: nodeDefinition, error } = await NodeDefinitionService.getById(nodeId);

    if (error) throw error;
    return nodeDefinition;
  }

  /**
   * Salva as configurações de um workflow
   * @param workflowId - ID do workflow
   * @param settings - Configurações do workflow
   */
  static async saveWorkflow(workflowId: string, settings: any) {
    try {
      await WorkflowBaseService.update(workflowId, { settings });
    } catch (error) {
      console.error(`Erro ao salvar workflow ${workflowId}:`, error);
      throw error;
    }
  }

  /**
   * Executa um nó do workflow - delegado para NodeService
   * Mantido para compatibilidade com código existente
   */
  static async executeNode(nodeId: string, config: any, workflowId: string) {
    return NodeService.executeNodeLegacy(nodeId, config, workflowId);
  }

  /**
   * Verifica o status de execução de um nó
   * @param executionId - ID da execução
   * @returns Status da execução
   */
  static async checkNodeExecutionStatus(executionId: string) {
    try {
      // Primeiro tenta usar o NodeService
      return await NodeService.checkNodeStatus(executionId);
    } catch (error) {
      console.log('Fallback para serviço dedicado após falha no NodeService', error);
      // Fallback para o NodeExecutionService se o NodeService falhar
      const { data, error: execError } = await NodeExecutionService.getById(executionId);

      if (execError) throw execError;
      return data;
    }
  }

  /**
   * Atualiza o status de execução de um nó
   * @param executionId - ID da execução
   * @param status - Novo status
   * @param output - Saída da execução
   */
  static async updateNodeExecutionStatus(executionId: string, status: string, output?: any) {
    const { error } = await NodeExecutionService.updateStatus(executionId, status, output);

    if (error) throw error;
  }
}
